export const PATH = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  BOT: '/bot',
  ENROLL_MFA: '/enroll-mfa',
  MFA: '/mfa',
  PRODUCTCHATBOT: '/products/chatbot',
  PRODUCTCONTENT: '/products/content',
  PRODUCTENRICHMENT: '/products/enrichment',
  PRODUCTSCHEDULING: '/products/scheduling',

  HOME: '/',
  BLOG_GRID: '/blog-grid',
  BLOG_SINGLE: '/blog-single',
  SIGN_UP: '/sign-up',
  EMAIL_VERIFICATION: '/email-verification',
  COMPLETE_PROFILE: '/complete-profile',
  SETUP_WORKSPACE: '/onboarding/workspace-setup',
  WORKFLOW_SELECTION: '/onboarding/workflow-selection',
  AI_ANALYSIS: '/onboarding/ai-analysis',
  WORKSPACE_INTENT: '/onboarding/workspace-intent',
  CREATE_WORKSPACE: '/onboarding/create-workspace',
  JOIN_WORKSPACE: '/onboarding/join-workspace',
  NOT_FOUND: '/404',
  VENDOR_LEADS: '/vendor-leads',
  VENDOR_SETTINGS: '/vendor-leads/settings',
  BOT_LIVE: '/bot-live',
  BOT_SUBSCRIPTION: '/bot/subscription',
  BOT_SUBSCRIPTION_CANCEL: '/bot/cancel',
  BOT_SUBSCRIPTION_SUCCESS: '/bot/success',
  IDEAS: '/contents/ideas',
  POSTS: '/contents/posts',
  SETTINGS: '/settings',
  CASE_STUDIES: '/case-studies',
  TEMPLATES: '/contents/templates',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  LOGOUT: '/logout',
  OFFERS: '/offers',
  INTEGRATION: '/integrations',
  AGENTS: '/agents',
  VOICE_AI: '/voice-ai',
  SIGNALS: '/signals',
  AUDIENCES: '/audiences',
  PLAYS: '/plays',
  WORKFLOWS_BUILDER: '/workflows/builder',
  INTERNAL_AGENTS: '/internal-agents',
  WORKFLOWS: '/workflows',

  PRICING: '/pricing',
  PLAYBOOKS: '/playbooks',
  HEYGEN: '/heygen',
};
